import "../../../../src/content/vietnam-festival/vietnam.scss";
import * as React from 'react';
export default {
  React
};